import { FC, PropsWithChildren } from "react";
import { IconButton, Tooltip } from "@mui/material";

interface IActionButtonProps {
  label: string;
  bgColor: string;
  bgColorHover: string;
  color: string;
  margin?: string;
  disabled?: boolean;
  customStyles?: object;
  dataTestId?: string;
  onClick?: () => void;
}

const ActionButton: FC<PropsWithChildren<IActionButtonProps>> = ({
  label,
  bgColor,
  bgColorHover,
  color,
  children,
  margin = "0",
  disabled = false,
  customStyles,
  dataTestId,
  onClick,
}) => (
  <Tooltip title={label} placement="top" arrow>
    <IconButton
      aria-label={label}
      disabled={disabled}
      sx={{
        backgroundColor: bgColor,
        color,
        margin,

        ":hover": {
          backgroundColor: bgColorHover,
        },

        ...customStyles,
      }}
      data-testid={dataTestId}
      {...(typeof onClick === "function" ? { onClick } : null)}
    >
      {children}
    </IconButton>
  </Tooltip>
);

export default ActionButton;
